import { c as _c } from "react/compiler-runtime";
import { Select } from '@onefootprint/ui';
import { useId } from 'react';
import type { Access } from '@/components/roles/utils/scope-environments';
type AccessOption = {
  value: Access;
  label: string;
};
type AccessSelectProps = {
  'aria-label': string;
  value: Access;
  onChange: (value: Access) => void;
  options: AccessOption[];
  disabled?: boolean;
};
const AccessSelect = t0 => {
  const $ = _c(10);
  const {
    "aria-label": ariaLabel,
    value,
    onChange,
    options,
    disabled
  } = t0;
  const id = useId();
  let t1;
  if ($[0] !== onChange || $[1] !== options) {
    t1 = next => {
      const option_0 = options.find(option => option.value === next);
      if (option_0) {
        onChange(option_0.value);
      }
    };
    $[0] = onChange;
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== ariaLabel || $[4] !== disabled || $[5] !== id || $[6] !== options || $[7] !== t1 || $[8] !== value) {
    t2 = <Select id={id} aria-label={ariaLabel} value={value} onChange={t1} options={options} disabled={disabled} size="compact" className="w-full" />;
    $[3] = ariaLabel;
    $[4] = disabled;
    $[5] = id;
    $[6] = options;
    $[7] = t1;
    $[8] = value;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
export type { AccessOption };
export default AccessSelect;